import styled from 'styled-components'
import { VARIANT_TO_RENDER } from '../../constants'

export const Button = styled.button<{ variant: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props =>
    props.variant === VARIANT_TO_RENDER.STATISTICS ? '#3a64f8' : 'white'};
  color: ${props => (props.variant === VARIANT_TO_RENDER.STATISTICS ? '#FBF6FE' : 'black')};
  border: none;
  border-radius: 5px;
  height: 5rem;
  padding: 0 2rem;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: pointer;

  @media (max-width: 1279px) {
    padding: 0px 1.2rem;
  }

  @media (max-width: 999px) {
    width: 100%;
    padding: 0px 2rem;
  }

  &:hover {
    color: ${props => (props.variant === VARIANT_TO_RENDER.STATISTICS ? 'white' : '#6B8BFA')};
    background-color: ${props =>
      props.variant === VARIANT_TO_RENDER.STATISTICS ? '#6B8BFA' : 'white'};
    transition: all 0.2s ease-out;
  }
`

export const ButtonTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`
